import { createContext } from 'react';

export const ModuleConfigContext = createContext<unknown | null>(null);
